
import React from 'react';

import Plasticstorag from './Plasticstorag';
import Plasticproduct from './Plasticproduct';
import Bucketandbox from './Bucketandbox';
import Abouttheiml from './Abouttheiml';
import Manufacturingsmachi from './Manufacturingsmachi';


const Plasticstorbox = () => {
    return (
        <div>
            <Plasticstorag />
            <Plasticproduct />
            <Bucketandbox />
            <Abouttheiml />
            <Manufacturingsmachi />
        </div>
    );
};

export default Plasticstorbox;
